export default "__VITE_ASSET__7b42df4f__"